import { Box, FormikSelectInputNative } from '@palmetto/palmetto-components';
import { Field } from 'formik';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { ProgramType } from 'types';

import { useGetModifiersQuery, useGetHoldbacksQuery, useGetItcModifiersQuery } from '../../../../services/pricing';
import { sortByLabel } from '../util';

const removeModifierOption = { label: 'x--Remove Modifier--x', value: 'remove' };
export const BulkEditModifiersFormSection = () => {
  const { programType } = useParams<{ programType: string }>();

  const { data: energyCommunityAdders = [] } = useGetItcModifiersQuery({
    type: 'energyCommunity',
    programType: programType as ProgramType,
  });
  const { data: ppwModifiers = [] } = useGetModifiersQuery({
    type: 'ppwAdjustment',
    programType: programType as ProgramType,
  });
  const { data: domesticContentModifiers = [] } = useGetItcModifiersQuery({
    type: 'domesticContent',
    programType: programType as ProgramType,
  });
  const { data: holdbacks = [] } = useGetHoldbacksQuery({ programType: programType as ProgramType });

  const holdbackOptions = useMemo(
    () => [
      removeModifierOption,
      ...holdbacks.map((hb: any) => ({ label: hb.name, value: hb.id })).toSorted(sortByLabel),
    ],
    [holdbacks],
  );
  const ppwModifierOptions = useMemo(
    () => [
      removeModifierOption,
      ...ppwModifiers.map((ppw: any) => ({ label: ppw.name, value: ppw.id })).toSorted(sortByLabel),
    ],
    [ppwModifiers],
  );

  const domesticContentModifierOptions = useMemo(
    () => [
      removeModifierOption,
      ...domesticContentModifiers.map((dc: any) => ({ label: dc.name, value: dc.id })).toSorted(sortByLabel),
    ],
    [domesticContentModifiers],
  );

  const energyCommunityOptions = useMemo(
    () => [
      removeModifierOption,
      ...energyCommunityAdders.map((ec: any) => ({ label: ec.name, value: ec.id })).toSorted(sortByLabel),
    ],
    [energyCommunityAdders],
  );
  return (
    <Box childGap="lg">
      <Field
        name="holdback"
        id="holdback"
        label="Holdback"
        component={FormikSelectInputNative}
        options={holdbackOptions}
      />
      <Field
        name="energyCommunity"
        id="energyCommunity"
        label="Energy Community"
        component={FormikSelectInputNative}
        options={energyCommunityOptions}
      />
      <Field
        name="ppwModifier"
        id="ppwModifier"
        label="PPW Modifier"
        component={FormikSelectInputNative}
        options={ppwModifierOptions}
      />
      <Field
        name="domesticContentModifier"
        id="domesticContentModifier"
        label="Domestic Content Modifier"
        component={FormikSelectInputNative}
        options={domesticContentModifierOptions}
      />
    </Box>
  );
};
